import { Download, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { PhotoSelection } from "@/hooks/use-photo-selection";

/**
 * Stays at the top of the page while photos are selected, so the count is always in view.
 * Esc clears the selection (`PhotosTab` listens for it).
 */
export function SelectionBar({
  selection,
  total,
  busy,
  onDownload,
}: {
  selection: PhotoSelection;
  /** Photos in the current list, loaded or not. */
  total: number;
  busy: boolean;
  onDownload: () => void;
}) {
  return (
    <div
      data-testid="selection-bar"
      className="sticky top-0 z-20 flex flex-wrap items-center gap-2 rounded-lg border bg-card px-3 py-2 shadow-md"
    >
      <span data-testid="selection-count" className="text-sm font-medium tabular-nums">
        {selection.count.toLocaleString("en-US")} selected
      </span>
      {selection.count < total && (
        <Button variant="ghost" size="sm" onClick={selection.selectAll}>
          Select all {total.toLocaleString("en-US")}
        </Button>
      )}
      <div className="ml-auto flex items-center gap-2">
        <Button size="sm" disabled={busy || selection.count === 0} onClick={onDownload}>
          <Download className="size-4" />
          Download
        </Button>
        <Button variant="ghost" size="sm" onClick={selection.clear} title="Clear selection (Esc)">
          <X className="size-4" />
          Clear
        </Button>
      </div>
    </div>
  );
}
